import { selectAuthReady,selectAuthUser, selectIsAuthenticated, useAuthStore } from '../auth.store';

/**
 * Hooks finos pra ler o estado de auth — selectors estáveis evitam
 * re-render desnecessário.
 */
export const useAuthUser = () => useAuthStore(selectAuthUser);
export const useIsAuthenticated = () => useAuthStore(selectIsAuthenticated);
export const useAuthReady = () => useAuthStore(selectAuthReady);

/** Ação de logout — encapsulada pra não vazar o store inteiro. */
export const useLogout = () => useAuthStore((s) => s.logout);

/** Ação de hidratar perfil (/me best-effort) — usada no fluxo de login. */
export const useLoadProfile = () => useAuthStore((s) => s.loadProfile);
